import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { of, take } from 'rxjs';
import { LocalStorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root',
})
export class AppService {

  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly router: Router
  ) { }

  initApp() {

    this.router.events.pipe(take(1)).subscribe(e => {
      if (e instanceof NavigationStart) {
        // console.log(e, localdata);
        return of();
      }
      return of();
    })

  }

}
